export default "__VITE_ASSET__BHbbkA8K__"